module.exports = __webpack_public_path__ + "assets/img/about-title.dac4e9cd.png";